module.exports = __webpack_public_path__ + "resources/img/phonegap.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/phonegap.png
// module id = 1105
// module chunks = 0